"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/app/services/datahub/constants");
const DatahubService_1 = __importDefault(require("modules/app/services/datahub/DatahubService"));
class DatahubCertificateService {
    constructor() {
        this.sendQRCodeEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: constants_1.GROUPS.CERTIFICATE_CONFIG,
                name: constants_1.NAMES.CERTIFICATE.SELECT_QR_CODE_TAG
            });
        };
        this.sendSaveWithQRCodeEvent = () => {
            DatahubService_1.default.sendMetrify({
                group: constants_1.GROUPS.CERTIFICATE_CONFIG,
                name: constants_1.NAMES.CERTIFICATE.SAVE_QR_CODE_TAG
            });
        };
    }
}
exports.default = new DatahubCertificateService();
